export default 'Rédiger une résolution travaux en AG : formulation juridique, majorité (art. 24/25/26) et pièces annexes. Modèles et accompagnement pour syndic et conseil syndical.';
